import { POST_API_PATH, GET_API_PATH } from "../../../constants"
import apiSetting from "../apiSetting"

const getDeliverRecordByDeliver = async (data) => {
    try {
        const queryParams = new URLSearchParams(data).toString();
        const response = await apiSetting({ method: 'GET', url: `${GET_API_PATH.GET_URL_DELIVERY_RECORD_BY_DELIVER}?${queryParams}`, data: null })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const ensureExistsDeliveryRecord = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_ENSUREEXISTS_DELIVER_RECORD, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const updateDeliveryRedcord = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_UPDATE_DELIVERY_RECORD, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const deleteDeliveryRedcord = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_DELETE_DELIVERY_RECORD, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

export { getDeliverRecordByDeliver, ensureExistsDeliveryRecord, updateDeliveryRedcord, deleteDeliveryRedcord } 